import { Component, OnInit } from '@angular/core';
import { APIService } from './../api.service';
//import { CommonService } from '../services/common.service';
import { MatSelect } from '@angular/material/select';
import { CommonService } from '../services/common.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { debug } from 'console';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-balance-sheet',
  templateUrl: './balance-sheet.component.html',
  styleUrls: ['./balance-sheet.component.scss']
})
export class BalanceSheetComponent implements OnInit {
  //#region "Declaration"
  jarvisData: any = [];
  LedgerRecord: any = [];
  HeadRecord: any = [];
  AccurateProfitOrLoss: any = [];
  profitAndLossParameters: any = [];
  ProfitOrLoss: number = 0;
  GrandIncome: number = 0;
  GrandExpense: number = 0;
  IncomeArray: any = [];
  ExpenseArray: any = [];
  BindRecordLeft: any = [];
  BindRecordRight: any = [];
  profitLoss: any = [];
  selectedFY: any;
  currentFY: any;
  financialYears: any = [];
  expand: boolean = false;
  hideZeroLevelLdgr: boolean = true;
  fromDate: any;
  toDate: any;
  selectedDate: any;
  imBaalance:any = 0;
  rightBal: any;
  leftBal: any;
  acctStartDT: Date = new Date();
  isShowLiabilities: boolean = true;
  isShowAssets: boolean = true;
  agencyData: any = [];
  ERP_Agn: any = [];
  right: any;

  isWeb: boolean = true;
  isMobileView: boolean = this.deviceService.isMobile();
  //#endregion

  //#region "Constructor"
  constructor(private apiService: APIService, private commonService: CommonService, private router: Router, private SpinnerService: NgxSpinnerService, private deviceService: DeviceDetectorService) { }
  //#endregion

  //#region "Declaration"
  ngOnInit(): void {
    let jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    };

    this.isWeb = this.apiService.apiCheckWeb();

    // Check Rights
    this.right = this.apiService.getCookie("J");
    if(this.right){
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
      if(!this.right.Accts){
        this.router.navigate(['/accounts'],);
        return;
      }
    }

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }

    //Get Account Start DT
    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
    }

    this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    // let accountsDate: any = this.apiService.getCookie("AccountsDates");
    // if (accountsDate) {
    //   accountsDate = JSON.parse(accountsDate);
    //   if (accountsDate.length > 0) {
    //     this.selectedFY = accountsDate[0].selectedFy;
    //     this.toDate = new Date(accountsDate[0].tdt);
    //     // this.toDate=this.toDate.replace(/%20/g, " ");
    //     this.fromDate = accountsDate[0].fdt;
    //     //this.fn_ChangeDate();

    //     if (this.selectedFY != "Other") {
    //       let selectedYear = this.selectedFY.split("-");
    //       let accountDate: Array<any> = [{
    //         fdt: '1-Apr-' + selectedYear[0],
    //         tdt: '31-Mar-' + selectedYear[1],
    //         selectedFy: this.selectedFY
    //       }];
    //       this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
    //     }
    //   }
    //   else {
    //     this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    //     let currentDate = new Date();
    //     this.fn_Set_FinancialYear(currentDate);
    //   }
    // }
    // else {
    //   this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    //   let currentDate = new Date();
    //   this.fn_Set_FinancialYear(currentDate);
    // }
    this.currentFY = this.financialYears[this.financialYears.length - 1].FY;
    this.selectedFY = this.currentFY;
    let currentDate = new Date();
    this.fn_Set_FinancialYear(currentDate);

    //this.selectedFY = '0';
    this.getData();

  }

  ddlchangeYear() {
    if (this.selectedFY != 'Other') {
      let selectedYear;
      selectedYear = this.selectedFY.split("-");
      let toDate = (Number(selectedYear[0]) + 1) + "/03/31";
      //this.selectedDate = toDate;

      // let accountDate: Array<any> = [{
      //   fdt: '1-Apr-' + selectedYear[0],
      //   tdt: '31-Mar-' + selectedYear[1],
      //   selectedFy: this.selectedFY
      // }];
      // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));

      this.fn_Set_FinancialYear(toDate);
    }
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }

    this.LedgerRecord = [];
    this.HeadRecord = [];
    this.AccurateProfitOrLoss = [];
    this.profitAndLossParameters = [];
    this.BindRecordLeft = [];
    this.BindRecordRight = [];

    // let accountDate: Array<any> = [{
    //   fdt: this.fromDate.customFormat("#DD#-#MMM#-#YY#"),
    //   tdt: this.toDate.customFormat("#DD#-#MMM#-#YY#"),
    //   selectedFy: this.selectedFY
    // }];
    // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));

    this.getData();
  }

  //getData() - Get Balanceshet data
  getData() {
    // this.SpinnerService.show();
    //this.refresh();
    let data = [{
      fromDT: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
      toDT: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#")
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 1,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  //failureResp - failure handler
  failureResp(res: any) {
    // this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      alert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(res: any) {
    // this.SpinnerService.hide();

    if (res.error) {
    }
    else {
      if (res) {
        let isHideZero = this.apiService.getCookie("hideZero");
        if (isHideZero) {
          this.hideZeroLevelLdgr = isHideZero == "true" ? true : false;
        }

        var reponseData = JSON.parse(res.updatePackage);

        if (reponseData.Table[0].ErrCode == 1000) {
          alert(reponseData.Table[0].ErrMsg);
          window.location.href = "main.html#/home";
          // this.router.navigateByUrl('/Stock');
        } else {
          this.LedgerRecord = reponseData.Table1;
          this.HeadRecord = reponseData.Table2;
          this.AccurateProfitOrLoss = reponseData.Table3;
          this.profitAndLossParameters = reponseData.Table4;
          this.fn_BindBalanceSheetData();
        }
      }
    }
  }

  //fn_BindBalanceSheetData() - Bind Data to balance sheet
  fn_BindBalanceSheetData() {
    this.BindRecordLeft = [];
    this.BindRecordRight = [];
    this.ProfitOrLoss = 0;
    this.GrandIncome = 0;
    this.GrandExpense = 0;
    this.IncomeArray = [];
    this.ExpenseArray = [];
    let headID: number = 0;

    //Left side data bind
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if (this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 2) {
        headID = this.HeadRecord[i].HeadID;
        this.BindRecordLeft.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0,
          SubHead: $.grep(this.HeadRecord, function (e: any) { return e.ParentHeadID == headID && e.LedgerType == 2 }), //  && e.CloBal != 0
          Ledger: $.grep(this.LedgerRecord, function (e: any) { return e.HeadID == headID }) //&& e.CloBal != 0
        });
      };
    }

    //Right side data bind
    headID = 0;
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if (this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 1) {
        headID = this.HeadRecord[i].HeadID;
        this.BindRecordRight.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0,
          SubHead: $.grep(this.HeadRecord, function (e: any) { return e.ParentHeadID == headID && e.LedgerType == 1 }), // && e.CloBal != 0 
          Ledger: $.grep(this.LedgerRecord, function (e: any) { return e.HeadID == headID }) // && e.CloBal != 0 
        });
      };
    }

    //Expense Data bind
    headID = 0;
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if (this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 4) {
        headID = this.HeadRecord[i].HeadID;
        this.ExpenseArray.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0
        });
      };
    }

    //income Data bind
    headID = 0;
    for (let i = 0; i < this.HeadRecord.length; i++) {
      if (this.HeadRecord[i].ParentHeadID == 0 && this.HeadRecord[i].LedgerType == 3) {
        headID = this.HeadRecord[i].HeadID;
        this.IncomeArray.push({
          HeadID: this.HeadRecord[i].HeadID,
          HeadName: this.HeadRecord[i].HeadName,
          CloBal: this.HeadRecord[i].CloBal,
          LedgerID: 0
        });
      };
    }

    if (this.LedgerRecord) {
      this.profitLoss = $.grep(this.LedgerRecord, function (i: any) { return i.LedgerName == "Profit & Loss A/c" });
      if (this.profitLoss.length > 0) {
        if (this.profitAndLossParameters) {
          this.profitLoss[0].totalProfitAndLoss = this.profitAndLossParameters[0].TotalProfitLoss;
          this.profitLoss[0].openingProfitAndLoss = this.profitAndLossParameters[0].OpeningProfitLoss;
          this.profitLoss[0].currentProfitAndLoss = this.profitAndLossParameters[0].CurrentProfitLoss;
        };
      }
    }

    this.GrandIncome = this.getIncomeTotal(this.IncomeArray, this.AccurateProfitOrLoss);
    this.GrandExpense = this.getExpenceTotal(this.ExpenseArray, this.AccurateProfitOrLoss);

    this.ProfitOrLoss = Number(this.GrandIncome) - Number(this.GrandExpense);

    if (this.ProfitOrLoss > 0) {
      this.GrandExpense += Number(String(this.ProfitOrLoss).replace(/\-/g, ""));
    } else {
      this.GrandIncome += Number(String(this.ProfitOrLoss).replace(/\-/g, ""));
    }

    // Left Side
    var LrftSideArrayLength = this.BindRecordLeft.length;
    var LeftSideBalance: any = 0;
    for (var i = 0; i < LrftSideArrayLength; i++) {
      LeftSideBalance += parseFloat(String(this.BindRecordLeft[i].CloBal).replace(/\,/g, ""));
    }
    if (this.ProfitOrLoss > 0 && this.profitLoss.length == 0) {
      LeftSideBalance += parseFloat(String(this.ProfitOrLoss));
    }
    else if (this.profitLoss.length > 0 && this.profitLoss[0].totalProfitAndLoss < 0) {
      LeftSideBalance += parseFloat(String(this.profitLoss[0].totalProfitAndLoss));
    }

    if (!this.AccurateProfitOrLoss) {
      this.AccurateProfitOrLoss = [];
    }
    if (this.AccurateProfitOrLoss.length > 0) {
      LeftSideBalance += parseFloat(String(this.AccurateProfitOrLoss[0].AccruedProfit));
    }

    // Right Side
    var RightSideArrayLength = this.BindRecordRight.length;
    var RightSideBalance = 0;
    for (var i = 0; i < RightSideArrayLength; i++) {
      RightSideBalance += parseFloat(String(this.BindRecordRight[i].CloBal).replace(/\,/g, ""));
    }
    if (this.ProfitOrLoss < 0 && this.profitLoss.length == 0) {
      RightSideBalance += parseFloat(String(this.ProfitOrLoss));
    }
    else if (this.profitLoss.length > 0 && this.profitLoss[0].totalProfitAndLoss > 0) {
      RightSideBalance += parseFloat(String(this.profitLoss[0].totalProfitAndLoss));
    }
    if (this.AccurateProfitOrLoss.length > 0) {
      RightSideBalance += parseFloat(String(this.AccurateProfitOrLoss[0].AccruedLoss));
      RightSideBalance += parseFloat(String(this.AccurateProfitOrLoss[0].ClosingStock));
    }

    let lftBal = parseFloat(String(LeftSideBalance).replace(/\-/g, "")).toFixed(2);
    let rgtBal = parseFloat(String(RightSideBalance).replace(/\-/g, "")).toFixed(2);

    this.imBaalance = Number(lftBal) - Number(rgtBal);

    this.rightBal = parseFloat(String(RightSideBalance));
    this.leftBal = parseFloat(String(LeftSideBalance));

  }

  getIncomeTotal(array: any, array1: any) {
    var total = 0;
    for (var i = 0; i < array.length; i++) {
      total += parseFloat(String(array[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));
    }
    return total;
  }

  getExpenceTotal(array: any, array1: any) {
    var total = 0;
    for (var i = 0; i < array.length; i++) {
      total += parseFloat(String(array[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));
    }
    return total;
  }

  fn_ChangeDate() {
    // Here Set Accounting Year of Selected Date
    var Date1 = new Date(this.toDate);
    var acctStartDT = new Date(this.acctStartDT);
    let CurrentDate = new Date();

    if (Date1 < acctStartDT) {
      alert("Please select date after " + this.acctStartDT.customFormat("#DD#-#MMM#-#YY#"));
      this.fn_Set_FinancialYear(CurrentDate);
      return;
    }

    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      //$scope.ToDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      // $scope.ToDate = new Date(Year + "/03/31");
    }

    //fn_HeadSummary();


    //fn_Set_FinancialYear($scope.ToDate);
    this.LedgerRecord = [];
    this.HeadRecord = [];
    this.AccurateProfitOrLoss = [];
    this.profitAndLossParameters = [];
    this.BindRecordLeft = [];
    this.BindRecordRight = [];

    // let accountDate: Array<any> = [{
    //   fdt: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
    //   tdt: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#"),
    //   selectedFy: this.selectedFY
    // }];
    // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
    this.getData();

  }

  backBtn() {
    this.router.navigate(['/heads'],);
    this.router.navigate(['/accounts'],);
  }

  Print() {
    var FDT = new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#");
    var TDT = new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#");
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    window.open('BalanceSheetPrint?FDT=' + FDT + '&TDT=' + TDT, target, 'Height= 900px, Width= 1000px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }


  refresh() {

    this.LedgerRecord = [];
    this.HeadRecord = [];
    this.AccurateProfitOrLoss = [];
    this.profitAndLossParameters = [];
    this.BindRecordLeft = [];
    this.BindRecordRight = [];

    this.getData();
  }

  goToAccounts(headID: any, h: any, fromDT: any, toDT: any) {
    
    // window.location.href = "accounts";
    let url = 'accounts;id=' + headID + ';h=' + h + ";fdt=" + new Date(fromDT).customFormat("#DD#-#MMM#-#YY#") + ";tdt=" + new Date(toDT).customFormat("#DD#-#MMM#-#YY#");
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    window.open(url, target);
  }

  //clickHideZero() -> hide zero the set cookie
  clickHideZero() {
    this.apiService.setCookie("hideZero", this.hideZeroLevelLdgr);
  }

   //goToPAndL(): Open Profit and loss
    goToPAndL() {
        let urlCheck: string = "";    
        if(this.apiService.fn_isLiveURL() == true) {
          urlCheck = "/ERP"
        }
        urlCheck = urlCheck + "/profitandLoss";
        let target: string = "_blank";
        if(this.isWeb == false){
          target = "_self";
        }
        window.open(urlCheck, target);
    };

  expandView(head: any, isHead: any) {
    if(this.isMobileView){
      this.goToAccounts(head.HeadID, 1, this.fromDate, this.toDate);
      return;
    }

    let target: string = "_blank";
    let isLive = this.apiService.fn_isLiveURL();
    let fromDT = new Date(this.fromDate).customFormat("#DD#-#MMM#-#YYYY#");
    let toDT = new Date(this.toDate).customFormat("#DD#-#MMM#-#YYYY#");
    if(this.isWeb == false){
      target = "_self";
    }

    if(isHead == '1') {
      let headID = head.HeadID;
      window.open((isLive ? '/ERP' : '') + '/HeadRecord?hid=' + encodeURIComponent(headID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT), target);
    } else {
      let ledgerID = head.LedgerID;
      window.open((isLive ? '/ERP' : '') + '/LedgerRecord?lid=' + encodeURIComponent(ledgerID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT), target);
    }
  }

  resetImbalance() {
    this.apiService.swalConfirm("Are you sure you want to reset the imbalance?", () => {
        this.SpinnerService.show(); 
        
        let data = [{
          calledFrom: 'BALANCESHEET'
        }];

        let myParams = [{
            myUserID: this.jarvisData[0].UserID,
            myToken: this.jarvisData[0].WebToken,
            forAgencyID: this.jarvisData[0].AgencyIDs,
            myAgencyIDs: this.jarvisData[0].AgencyIDs,
            myLastSyncDT: null,
            isWeb: true,
            ForERPAgencyID: this.agencyData[0].ERPAgencyID,
            actionType: 'addYearlyProfitAndLoss',
            moduleID: 11,
            data: JSON.stringify(data)
        }];

        this.apiService.sendChange(myParams, this.resetImbalanceSuccess.bind(this), this.resetImbalanceFailure.bind(this));
    });
  }

  // Success handler
  resetImbalanceSuccess(res: any) {
    if (res.error) {
        console.log('Balance imbalance failed:', res.message);
    } else {
      alert('Imbalance reset.');
      this.getData();
    }
  }

  // Failure handler
  resetImbalanceFailure(res: any) {
    if (res.error) {
        console.log('Balance imbalance request failed:', res.error);
    } else {
        alert(res.message);
    }
  }

  //#endregion
}

declare global {
  interface Date {
    customFormat(formatString: any): string;
  }
}


// String Prototye
Date.prototype.customFormat = function (formatString: any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}

